(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eloence-cart-drawer"] && !Shopify.designMode) return;
  try {
    
/* Cart-drawer CRO blocks — gift-note input is wired here; the rest hook into
   the existing assets/eloence-ui.js (progress, xsell) and assets/eloence-cart.js
   (line items, subtotal). Keep the wiring idempotent — re-runs on
   `eloence:cart:opened` and `shopify:section:load`. */
(function () {
  var GIFT_NOTE_KEY = 'gift_note';
  var DEBOUNCE_MS = 600;

  function wireGiftNote(scope) {
    var blocks = scope.querySelectorAll('[data-el-giftnote]');
    if (!blocks.length) return;
    blocks.forEach(function (block) {
      if (block.dataset.elWired === '1') return;
      block.dataset.elWired = '1';

      var toggle = block.querySelector('[data-el-giftnote-toggle]');
      var wrap = block.querySelector('[data-el-giftnote-wrap]');
      var input = block.querySelector('[data-el-giftnote-input]');

      if (toggle && wrap) {
        toggle.addEventListener('change', function () {
          if (toggle.checked) {
            wrap.removeAttribute('hidden');
            if (input) setTimeout(function () { input.focus(); }, 50);
          } else {
            wrap.setAttribute('hidden', '');
            if (input && input.value) {
              input.value = '';
              persist('');
            }
          }
        });
      }

      if (input) {
        var timer = null;
        input.addEventListener('input', function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            persist(input.value);
          }, DEBOUNCE_MS);
        });
      }

      function persist(value) {
        if (!window.ELOENCE_CART || !window.ELOENCE_CART.updateAttributes) return;
        var attrs = {};
        attrs[GIFT_NOTE_KEY] = value || '';
        window.ELOENCE_CART.updateAttributes(attrs).catch(function (err) {
          if (window.console && window.console.debug) window.console.debug('[el-giftnote]', err);
        });
      }
    });
  }

  /* ---------- Urgence : compte à rebours « panier réservé » ----------
     L'échéance est stockée dans localStorage : elle ne repart pas à chaque
     ouverture du tiroir ni à chaque page. Elle démarre quand le panier passe
     de vide à rempli et s'efface quand il redevient vide. À 00:00 on affiche
     le message d'expiration, sans redémarrer (décision Nicolas 2026-09-24). */
  var URG_KEY = 'eloence:cart:reserve:v1';
  var urgMemory = null; /* repli si localStorage est indisponible */
  var urgTimer = null;

  function urgRead() {
    try {
      var raw = localStorage.getItem(URG_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return urgMemory; }
  }
  function urgWrite(v) {
    urgMemory = v;
    try {
      if (v) localStorage.setItem(URG_KEY, JSON.stringify(v));
      else localStorage.removeItem(URG_KEY);
    } catch (e) { /* mémoire seule */ }
  }
  function urgFormat(ms) {
    var total = Math.max(0, Math.ceil(ms / 1000));
    var m = Math.floor(total / 60);
    var sec = total % 60;
    return (m < 10 ? '0' : '') + m + ':' + (sec < 10 ? '0' : '') + sec;
  }
  function urgPaint() {
    var blocks = document.querySelectorAll('[data-el-urgency]');
    if (!blocks.length) return false;
    var rec = urgRead();
    var running = false;
    blocks.forEach(function (el) {
      var minutes = parseInt(el.getAttribute('data-minutes'), 10) || 10;
      var remaining = rec ? rec.deadline - Date.now() : minutes * 60000;
      var live = el.querySelector('[data-el-urgency-live]');
      var expired = el.querySelector('[data-el-urgency-expired]');
      var time = el.querySelector('[data-el-urgency-time]');
      if (remaining > 0) {
        if (time) time.textContent = urgFormat(remaining);
        if (live) live.hidden = false;
        if (expired) expired.hidden = true;
        el.classList.remove('is-expired');
        if (rec) running = true;
      } else {
        if (live) live.hidden = true;
        if (expired) expired.hidden = false;
        el.classList.add('is-expired');
      }
    });
    return running;
  }
  function urgTick() {
    if (urgTimer) clearInterval(urgTimer);
    urgTimer = null;
    if (urgPaint()) {
      urgTimer = setInterval(function () {
        if (!urgPaint()) { clearInterval(urgTimer); urgTimer = null; }
      }, 1000);
    }
  }
  function urgOnCart(state) {
    var blocks = document.querySelectorAll('[data-el-urgency]');
    if (!blocks.length) return;
    var minutes = parseInt(blocks[0].getAttribute('data-minutes'), 10) || 10;
    var rec = urgRead();
    if (state && state.item_count > 0) {
      /* Nouvelle réservation si aucune en cours, ou si la durée a changé dans l'éditeur. */
      if (!rec || rec.minutes !== minutes) {
        urgWrite({ deadline: Date.now() + minutes * 60000, minutes: minutes });
      }
    } else if (window.ELOENCE_CART && window.ELOENCE_CART.isReady && window.ELOENCE_CART.isReady()) {
      /* Panier vide confirmé par le serveur (pas l'état vide pré-hydratation). */
      urgWrite(null);
    }
    urgTick();
  }
  var urgSubscribed = false;
  function wireUrgency() {
    if (urgSubscribed) { urgTick(); return; }
    if (!window.ELOENCE_CART || !window.ELOENCE_CART.subscribe) return;
    urgSubscribed = true;
    window.ELOENCE_CART.subscribe(urgOnCart);
  }

  /* iOS Safari n'applique :active au toucher que si un écouteur touchstart existe. */
  document.addEventListener('touchstart', function () {}, { passive: true });

  /* « 1 article » / « 3 articles » dans l'en-tête du tiroir (eloence-ui.js ne met à jour que le chiffre). */
  var countSubscribed = false;
  function wireCountLabel() {
    if (countSubscribed || !window.ELOENCE_CART || !window.ELOENCE_CART.subscribe) return;
    countSubscribed = true;
    window.ELOENCE_CART.subscribe(function (state) {
      if (window.ELOENCE_CART.isReady && !window.ELOENCE_CART.isReady()) return;
      document.querySelectorAll('[data-el-drawer-count-label]').forEach(function (el) {
        el.textContent = state.item_count > 1 ? 'articles' : 'article';
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-el-cart-drawer]').forEach(wireGiftNote);
    wireUrgency();
    wireCountLabel();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('eloence:cart:opened', init);
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eloence-collection-filters"] && !Shopify.designMode) return;
  try {
    
(function () {
  function isDesktop() { return window.matchMedia('(min-width: 900px)').matches; }

  function init(root) {
    if (!root || root.dataset.elCfiltersInit === '1') return;
    root.dataset.elCfiltersInit = '1';
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-el-cfilters-group]'));

    /* Ordinateur : un seul menu ouvert à la fois, fermeture au clic extérieur et sur Échap. */
    groups.forEach(function (g) {
      g.addEventListener('toggle', function () {
        if (!g.open || !isDesktop()) return;
        groups.forEach(function (other) { if (other !== g) other.open = false; });
      });
    });
    document.addEventListener('click', function (e) {
      if (!isDesktop() || root.contains(e.target) && e.target.closest('[data-el-cfilters-group]')) return;
      groups.forEach(function (g) { g.open = false; });
    });
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      groups.forEach(function (g) {
        if (g.open) { g.open = false; var s = g.querySelector('summary'); if (s) s.focus(); }
      });
    });

    /* Mobile : le bouton « Filtrer » déplie la liste des filtres. */
    var toggle = root.querySelector('[data-el-cfilters-toggle]');
    var list = root.querySelector('[data-el-cfilters-groups]');
    if (toggle && list) {
      toggle.addEventListener('click', function () {
        var open = !list.classList.contains('is-open');
        list.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }

    /* Le tri s'applique tout de suite ; les cases attendent « Appliquer », comme chez la référence. */
    var sort = root.querySelector('[data-el-cfilters-sort]');
    var form = root.querySelector('[data-el-cfilters-form]');
    if (sort && form) {
      sort.addEventListener('change', function () {
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      });
    }

    /* Champs de prix vides : on les retire pour ne pas envoyer de paramètre vide. */
    if (form) {
      form.addEventListener('submit', function () {
        form.querySelectorAll('input[type="number"]').forEach(function (i) {
          if (i.value === '') i.disabled = true;
        });
      });
    }
  }

  function boot() { document.querySelectorAll('[data-el-cfilters]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eloence-faq"] && !Shopify.designMode) return;
  try {
    
/* Editeur de theme : selectionner une question dans la barre laterale l'ouvre
   dans l'apercu et referme les autres. Les <details> portent
   {{ block.shopify_attributes }}, ils sont donc la cible de l'evenement.

   Sans ca, editer la 5e question obligeait a la rechercher et la rouvrir a la
   main apres chaque rechargement de l'apercu.

   Le garde sur window.Eloence couvre l'ordre de chargement entre ce bundle et
   eloence-ui.js, ou vit le helper. */
if (window.Eloence && window.Eloence.bindDetailsBlockSelect) {
  window.Eloence.bindDetailsBlockSelect('[data-el-faq]', 'details.el-faq__item');
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eloence-filter-drawer"] && !Shopify.designMode) return;
  try {
    
(function () {
  var AXIS_KEYS = ['famille', 'intensite', 'ambiance', 'occasion', 'note', 'budget'];
  // Map URL/pill axis key → data-attr suffix on cards.
  var AXIS_TO_DATA = {
    famille:   'fam',
    intensite: 'int',
    ambiance:  'amb',
    occasion:  'occ',
    note:      'note',
    budget:    'budget'
  };

  document.querySelectorAll('[data-el-filter]').forEach(function (root) {
    var trigger      = root.querySelector('[data-el-filter-trigger]');
    var drawer       = root.querySelector('[data-el-filter-drawer]');
    if (!trigger || !drawer) return;

    var panel        = drawer.querySelector('.el-filter-drawer__panel');
    var scrim        = drawer.querySelector('[data-el-filter-scrim]');
    var closeBtn     = drawer.querySelector('[data-el-filter-close]');
    var applyBtn     = drawer.querySelector('[data-el-filter-apply]');
    var resetBtn     = drawer.querySelector('[data-el-filter-reset]');
    var pills        = drawer.querySelectorAll('[data-el-pill]');
    var countBadge   = trigger.querySelector('[data-el-filter-count]');
    var resultCount  = drawer.querySelector('[data-el-filter-result-count]');

    // Cards and empty state live in a sibling section (eloence-collection-grid).
    // We query the whole document because grid section ID isn't known here.
    var cards         = function () { return document.querySelectorAll('[data-el-card]'); };
    var gridEl        = function () { return document.getElementById('el-coll-grid') || document.querySelector('[data-el-grid]'); };
    var emptyEl       = function () { return document.querySelector('[data-el-filtered-empty]'); };
    var filteredReset = function () { return document.querySelector('[data-el-filtered-reset]'); };

    // --- State --------------------------------------------------------------
    // state[axis] = Set of selected slug values.
    var state = {};
    AXIS_KEYS.forEach(function (k) { state[k] = new Set(); });

    function activeCount() {
      var n = 0;
      AXIS_KEYS.forEach(function (k) { n += state[k].size; });
      return n;
    }

    function syncTriggerCount() {
      var n = activeCount();
      if (countBadge) {
        if (n > 0) { countBadge.textContent = String(n); countBadge.hidden = false; }
        else { countBadge.hidden = true; }
      }
    }

    function cardMatchesAxis(card, axis, values) {
      if (values.size === 0) return true;
      var raw = card.getAttribute('data-' + AXIS_TO_DATA[axis]) || '';
      if (raw === '') return false; // no declared value on this axis → filtered out
      var cardValues = raw.split(',');
      // OR within axis: any selected value present on card → match.
      var matched = false;
      values.forEach(function (v) { if (cardValues.indexOf(v) !== -1) matched = true; });
      return matched;
    }

    function countMatches() {
      var matches = 0;
      cards().forEach(function (card) {
        var pass = true;
        AXIS_KEYS.forEach(function (axis) {
          if (pass && !cardMatchesAxis(card, axis, state[axis])) pass = false;
        });
        if (pass) matches += 1;
      });
      return matches;
    }

    function syncResultCount() {
      if (resultCount) resultCount.textContent = String(countMatches());
    }

    // --- Drawer open/close --------------------------------------------------
    var lastFocused = null;

    function trapHandler(e) {
      if (e.key !== 'Tab') return;
      var focusables = panel.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
      if (!focusables.length) return;
      var first = focusables[0], last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
      else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
    }

    function escHandler(e) { if (e.key === 'Escape') closeDrawer(); }

    function openDrawer() {
      lastFocused = document.activeElement;
      drawer.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      root.classList.add('el-filter--open');
      document.body.classList.add('el-filter--locked');
      // Focus first focusable (close button).
      setTimeout(function () { if (closeBtn) closeBtn.focus(); }, 30);
      document.addEventListener('keydown', escHandler);
      panel.addEventListener('keydown', trapHandler);
    }

    function closeDrawer() {
      drawer.setAttribute('aria-hidden', 'true');
      trigger.setAttribute('aria-expanded', 'false');
      root.classList.remove('el-filter--open');
      document.body.classList.remove('el-filter--locked');
      document.removeEventListener('keydown', escHandler);
      panel.removeEventListener('keydown', trapHandler);
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    trigger.addEventListener('click', function () {
      if (drawer.getAttribute('aria-hidden') === 'false') closeDrawer();
      else openDrawer();
    });
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (scrim) scrim.addEventListener('click', closeDrawer);

    // --- Pill toggling (doesn't apply, just updates state, URL & preview count) --
    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var axis = pill.getAttribute('data-axis');
        var value = pill.getAttribute('data-value');
        if (!axis || !value || !state[axis]) return;
        var pressed = pill.getAttribute('aria-pressed') === 'true';
        if (pressed) { state[axis].delete(value); pill.setAttribute('aria-pressed', 'false'); }
        else { state[axis].add(value); pill.setAttribute('aria-pressed', 'true'); }
        syncTriggerCount();
        syncResultCount();
        writeToUrl();
      });
    });

    // --- Apply / Reset ------------------------------------------------------
    function updateHeaderCount(visibleCount) {
      var headerN = document.querySelector('[data-el-grid-count-n]');
      if (headerN) headerN.textContent = String(visibleCount);
    }

    function updateEmptyText() {
      var msg = root.getAttribute('data-empty-message') || '';
      if (!msg) return;
      var t = document.querySelector('[data-el-filtered-empty-text]');
      if (t) t.textContent = msg;
    }

    function applyFilters() {
      var visible = 0;
      cards().forEach(function (card) {
        var pass = true;
        AXIS_KEYS.forEach(function (axis) {
          if (pass && !cardMatchesAxis(card, axis, state[axis])) pass = false;
        });
        if (pass) { card.classList.remove('el-coll__card--hidden'); visible += 1; }
        else { card.classList.add('el-coll__card--hidden'); }
      });

      var empty = emptyEl();
      if (empty) {
        empty.hidden = visible > 0;
        if (!empty.hidden) updateEmptyText();
      }

      updateHeaderCount(visible);
      writeToUrl();

      // Brief loading flash on the Apply button so the tap feels tactile before the drawer closes.
      if (applyBtn) {
        applyBtn.classList.add('is-loading');
        applyBtn.setAttribute('aria-busy', 'true');
      }
      setTimeout(function () {
        if (applyBtn) {
          applyBtn.classList.remove('is-loading');
          applyBtn.removeAttribute('aria-busy');
        }
        closeDrawer();
        var grid = gridEl();
        if (grid && 'scrollIntoView' in grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 200);
    }

    function resetFilters() {
      AXIS_KEYS.forEach(function (k) { state[k].clear(); });
      pills.forEach(function (p) { p.setAttribute('aria-pressed', 'false'); });
      var total = 0;
      cards().forEach(function (c) { c.classList.remove('el-coll__card--hidden'); total += 1; });
      var empty = emptyEl();
      if (empty) empty.hidden = true;
      updateHeaderCount(total);
      syncTriggerCount();
      syncResultCount();
      writeToUrl();
    }

    if (applyBtn) applyBtn.addEventListener('click', applyFilters);
    if (resetBtn) resetBtn.addEventListener('click', resetFilters);
    var inlineReset = filteredReset();
    if (inlineReset) inlineReset.addEventListener('click', resetFilters);

    // --- URL persistence ----------------------------------------------------
    function writeToUrl() {
      try {
        var url = new URL(window.location.href);
        AXIS_KEYS.forEach(function (axis) {
          if (state[axis].size > 0) {
            url.searchParams.set(axis, Array.from(state[axis]).join(','));
          } else {
            url.searchParams.delete(axis);
          }
        });
        window.history.replaceState({}, '', url.toString());
      } catch (e) { /* no-op, URL API unsupported */ }
    }

    function readFromUrl() {
      try {
        var params = new URL(window.location.href).searchParams;
        AXIS_KEYS.forEach(function (axis) {
          var v = params.get(axis);
          if (!v) return;
          v.split(',').forEach(function (val) { if (val) state[axis].add(val); });
        });
        // Sync pills to state.
        pills.forEach(function (pill) {
          var axis = pill.getAttribute('data-axis');
          var value = pill.getAttribute('data-value');
          if (state[axis] && state[axis].has(value)) pill.setAttribute('aria-pressed', 'true');
        });
        // If any filters were restored, apply immediately on load.
        if (activeCount() > 0) {
          cards().forEach(function (card) {
            var pass = true;
            AXIS_KEYS.forEach(function (axis) {
              if (pass && !cardMatchesAxis(card, axis, state[axis])) pass = false;
            });
            if (!pass) card.classList.add('el-coll__card--hidden');
          });
          var empty = emptyEl();
          if (empty && document.querySelectorAll('[data-el-card]:not(.el-coll__card--hidden)').length === 0) {
            empty.hidden = false;
            updateEmptyText();
          }
          // Sync header count on load if filters restored.
          updateHeaderCount(document.querySelectorAll('[data-el-card]:not(.el-coll__card--hidden)').length);
        }
      } catch (e) { /* no-op */ }
    }

    readFromUrl();
    syncTriggerCount();
    syncResultCount();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eloence-ig-stories"] && !Shopify.designMode) return;
  try {
    
(function(){
  // YouTube lazy embed
  document.querySelectorAll('[data-el-lazy-yt]').forEach(function(wrap) {
    wrap.addEventListener('click', function() {
      var ytId = wrap.dataset.ytId;
      if (!ytId) return;
      var iframe = document.createElement('iframe');
      iframe.setAttribute('src', 'https://www.youtube.com/embed/' + ytId + '?autoplay=1&rel=0');
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.className = 'el-story__video-iframe-real';
      wrap.innerHTML = '';
      wrap.appendChild(iframe);
    });
  });
  // Vimeo lazy embed
  document.querySelectorAll('[data-el-lazy-vimeo]').forEach(function(wrap) {
    wrap.addEventListener('click', function() {
      var vmId = wrap.dataset.vimeoId;
      if (!vmId) return;
      var iframe = document.createElement('iframe');
      iframe.setAttribute('src', 'https://player.vimeo.com/video/' + vmId + '?autoplay=1&title=0&byline=0&portrait=0');
      iframe.setAttribute('frameborder', '0');
      iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.className = 'el-story__video-iframe-real';
      wrap.innerHTML = '';
      wrap.appendChild(iframe);
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eloence-image-text"] && !Shopify.designMode) return;
  try {
    
/* Image + texte : pastilles de variante + ajout au panier en AJAX (ouvre le tiroir).
   Sans JS ou sans ELOENCE_CART, le formulaire poste vers /cart/add normalement. */
(function () {
  function setLabel(form, variantBtn) {
    var btn = form.querySelector('[data-el-imgtext-atc-btn]');
    var label = form.querySelector('[data-el-imgtext-atc-label]');
    if (!btn || !label) return;
    var available = !variantBtn || variantBtn.getAttribute('data-available') === 'true';
    btn.disabled = !available;
    if (!available) { label.textContent = btn.getAttribute('data-soldout'); return; }
    var text = btn.getAttribute('data-label');
    if (btn.getAttribute('data-show-price') === 'true' && variantBtn) {
      text += ' · ' + variantBtn.getAttribute('data-price');
    }
    if (variantBtn || btn.getAttribute('data-show-price') !== 'true') label.textContent = text;
  }

  document.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-el-imgtext-variant]');
    if (!pill) return;
    var form = pill.closest('[data-el-imgtext-atc]');
    if (!form) return;
    form.querySelectorAll('[data-el-imgtext-variant]').forEach(function (b) {
      var on = b === pill;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    var idInput = form.querySelector('[data-el-imgtext-atc-id]');
    if (idInput) idInput.value = pill.getAttribute('data-variant-id');
    setLabel(form, pill);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-el-imgtext-atc]');
    if (!form || !window.ELOENCE_CART || !window.ELOENCE_CART.add) return;
    e.preventDefault();
    var btn = form.querySelector('[data-el-imgtext-atc-btn]');
    var id = parseInt(form.querySelector('[data-el-imgtext-atc-id]').value, 10);
    if (!id || (btn && btn.disabled)) return;
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
    window.ELOENCE_CART.add(id, 1).then(function () {
      window.ELOENCE_CART.openDrawer();
    }).catch(function (err) {
      if (window.console && console.debug) console.debug('[el-imgtext]', err);
    }).then(function () {
      if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eloence-pdp-hero"] && !Shopify.designMode) return;
  try {
    
/* Editeur de theme : selectionner un bloc 'accordion' dans la barre laterale
   l'ouvre dans l'apercu et referme les autres.

   Ne concerne que ce type de bloc : les 14 autres types de la fiche produit
   (eyebrow, title, rating, price, bullets, variant_selector, quantity_atc,
   payment_icons, delivery, trust_row, tagline_pill, inspired_pill, guarantee,
   urgency-strip) sont rendus en place et simultanement, ils n'ont aucun etat a
   piloter. Le selecteur details.el-pdp__accordion s'en charge naturellement.

   Le garde sur window.Eloence couvre l'ordre de chargement entre ce bundle et
   eloence-ui.js, ou vit le helper. */
if (window.Eloence && window.Eloence.bindDetailsBlockSelect) {
  window.Eloence.bindDetailsBlockSelect('.el-pdp', 'details.el-pdp__accordion');
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eloence-pdp-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initTabs(root) {
    if (!root || root.dataset.elPdpTabsInit === '1') return;
    root.dataset.elPdpTabsInit = '1';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length || !panels.length) return;

    function activate(index, opts) {
      opts = opts || {};
      if (index < 0) index = tabs.length - 1;
      if (index >= tabs.length) index = 0;

      tabs.forEach(function (tab, i) {
        var on = i === index;
        tab.classList.toggle('is-active', on);
        tab.setAttribute('aria-selected', on ? 'true' : 'false');
        tab.setAttribute('tabindex', on ? '0' : '-1');
      });
      panels.forEach(function (panel, i) {
        var on = i === index;
        panel.classList.toggle('is-active', on);
        if (on) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      });

      if (opts.focus) tabs[index].focus();
      if (opts.scroll !== false) {
        try {
          tabs[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        } catch (e) { /* navigateurs anciens */ }
      }
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () { activate(i, { focus: false }); });
      tab.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = i + 1;
        else if (e.key === 'ArrowLeft') next = i - 1;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        else return;
        e.preventDefault();
        activate(next, { focus: true });
      });
    });

    if (!tabs.some(function (t) { return t.classList.contains('is-active'); })) {
      activate(0, { focus: false, scroll: false });
    }

    root._elTabsActivate = activate;
  }

  function boot() {
    document.querySelectorAll('[data-el-pdp-tabs]').forEach(initTabs);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* L'editeur remplace le DOM de la section sans recharger la page. */
  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target || !e.target.querySelectorAll) return;
    e.target.querySelectorAll('[data-el-pdp-tabs]').forEach(initTabs);
  });

  /* Selectionner un bloc dans l'editeur ouvre l'onglet correspondant.
     shopify_attributes est porte par le <button role="tab">. Ecouteur direct
     plutot que le helper window.Eloence : l'ordre de chargement des bundles
     n'est pas garanti. */
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    if (!el || !el.closest) return;
    var root = el.closest('[data-el-pdp-tabs]');
    if (!root || typeof root._elTabsActivate !== 'function') return;
    var tab = el.matches('[role="tab"]') ? el : el.closest('[role="tab"]');
    if (!tab) return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var idx = tabs.indexOf(tab);
    if (idx >= 0) root._elTabsActivate(idx, { focus: false });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eloence-pourquoi"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initPourquoi(root) {
    if (!root || root.dataset.elPourquoiInit === '1') return;
    root.dataset.elPourquoiInit = '1';

    var tablist = root.querySelector('[role="tablist"]');
    if (!tablist) return;
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
    if (!tabs.length || !panels.length) return;

    // If no tab is marked active (e.g. default_tab exceeds actual reason count), activate the first.
    var hasActive = tabs.some(function (t) { return t.classList.contains('is-active'); });
    if (!hasActive) {
      tabs[0].classList.add('is-active');
      tabs[0].setAttribute('aria-selected', 'true');
      tabs[0].setAttribute('tabindex', '0');
      if (panels[0]) {
        panels[0].classList.add('is-active');
        panels[0].removeAttribute('hidden');
      }
    }

    /* Indicateur glissant : se cale sur l'onglet actif (largeur + position).
       offsetLeft est relatif à la tablist (position: relative) : l'indicateur
       défile avec les onglets si la rangée déborde. */
    var indicator = tablist.querySelector('.el-pourquoi__indicator');
    function placeIndicator() {
      if (!indicator) return;
      var current = tablist.querySelector('[role="tab"].is-active');
      if (!current) return;
      indicator.style.width = current.offsetWidth + 'px';
      /* left (pas transform) : un transform créerait un contexte d'empilement et
         enfermerait le trait bordeaux sous le trait gris des onglets. */
      indicator.style.left = current.offsetLeft + 'px';
    }
    if (indicator) {
      placeIndicator();
      tablist.classList.add('has-indicator');
      /* Transition activée après la première pose : pas de glissement au chargement. */
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { tablist.classList.add('is-animated'); });
      });
      /* Les largeurs changent quand la police se charge ou que l'écran change de taille. */
      if (window.ResizeObserver) {
        new ResizeObserver(placeIndicator).observe(tablist);
      } else {
        window.addEventListener('resize', placeIndicator);
      }
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(placeIndicator);
    }

    function activate(index, opts) {
      opts = opts || {};
      if (index < 0) index = tabs.length - 1;
      if (index >= tabs.length) index = 0;

      tabs.forEach(function (tab, i) {
        var active = i === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
      });

      placeIndicator();

      panels.forEach(function (panel, i) {
        var active = i === index;
        panel.classList.toggle('is-active', active);
        if (active) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      });

      if (opts.focus !== false) {
        tabs[index].focus();
      }
      if (opts.scroll !== false) {
        try {
          tabs[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        } catch (e) { /* older browsers */ }
      }
    }

    tabs.forEach(function (tab, i) {
      tab.addEventListener('click', function () {
        activate(i, { focus: false });
      });
      tab.addEventListener('keydown', function (event) {
        var key = event.key;
        if (key === 'ArrowRight') {
          event.preventDefault();
          activate(i + 1);
        } else if (key === 'ArrowLeft') {
          event.preventDefault();
          activate(i - 1);
        } else if (key === 'Home') {
          event.preventDefault();
          activate(0);
        } else if (key === 'End') {
          event.preventDefault();
          activate(tabs.length - 1);
        } else if (key === 'Enter' || key === ' ' || key === 'Spacebar') {
          event.preventDefault();
          activate(i, { focus: false });
        }
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-el-pourquoi]').forEach(initPourquoi);
  }

  /* Editeur de theme : selectionner une raison dans la barre laterale active
     son onglet dans l'apercu. C'est LE defaut signale par le proprietaire :
     les onglets repondent au clic sur le site public, mais l'editeur pilote
     par selection de bloc, pas par clic.

     {{ block.shopify_attributes }} est porte par le <button role="tab">, qui
     est donc la cible de l'evenement.

     On declenche un click() synthetique plutot que d'appeler activate() :
     cette fonction est enfermee dans la closure de initPourquoi et n'est pas
     atteignable ici. Le gestionnaire de clic deja cable fait le travail.

     Le garde sur window.Eloence couvre l'ordre de chargement entre ce bundle
     et eloence-ui.js. */
  if (window.Eloence && window.Eloence.onBlockSelect) {
    window.Eloence.onBlockSelect('[data-el-pourquoi]', function (root, block) {
      var tab = (block.matches && block.matches('[role="tab"]'))
        ? block
        : (block.closest ? block.closest('[role="tab"]') : null);
      if (!tab) return;
      /* indexOf sert de garde d'appartenance : on ne pilote que les onglets
         de CETTE section, pas ceux d'une autre instance sur la meme page. */
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
      if (tabs.indexOf(tab) < 0) return;
      tab.click();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    var root = event.target.querySelector('[data-el-pourquoi]');
    if (root) initPourquoi(root);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eloence-social-proof-wall"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Défilement lié au scroll (pas d'autoplay) : chaque rangée glisse d'autant
     plus que la page défile, direction et vitesse propres à la rangée.
     translateX = progression du scroll à travers la section (0 → 1) ×
     vitesse × distance max de la rangée (largeur du contenu qui dépasse). */
  function initSpw(root) {
    if (!root || root.dataset.elSpwInit === '1') return;
    root.dataset.elSpwInit = '1';

    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-el-spw-row]'));
    if (!rows.length) return;

    var prefersReducedMotion = (typeof window.matchMedia === 'function')
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) return; /* rangées statiques ; la règle CSS le garantit aussi */

    var state = rows.map(function (row) {
      return {
        row: row,
        track: row.querySelector('[data-el-spw-track]'),
        direction: row.getAttribute('data-el-spw-direction') === 'right' ? 'right' : 'left',
        speed: parseFloat(row.getAttribute('data-el-spw-speed')) || 1,
        maxShift: 0
      };
    });

    function measure() {
      state.forEach(function (s) {
        if (!s.track) return;
        s.maxShift = Math.max(0, s.track.scrollWidth - s.row.clientWidth);
        /* Pas assez d'images pour déborder la largeur de la rangée (typique
           en desktop avec peu de blocs) : rien à faire glisser, on centre
           la rangée au lieu de la laisser collée à gauche dans le vide. */
        s.row.classList.toggle('el-spw__row--fits', s.maxShift <= 0);
      });
    }

    var ticking = false;
    function update() {
      ticking = false;
      var rect = root.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var total = rect.height + vh;
      var traveled = vh - rect.top;
      var progress = total > 0 ? traveled / total : 0;
      if (progress < 0) progress = 0;
      if (progress > 1) progress = 1;

      state.forEach(function (s) {
        if (!s.track || s.maxShift <= 0) return;
        var shift = progress * s.speed * s.maxShift;
        if (shift > s.maxShift) shift = s.maxShift;
        /* 'left' : repos = premiere carte visible (x=0), glisse vers -maxShift
           (revele la fin de la piste). 'right' doit etre le miroir exact,
           pas juste le signe inverse — sinon la piste part de x=0 (premiere
           carte) et glisse vers +maxShift : rien ne comble la gauche pendant
           que la droite sort du cadre, d'ou l'espace vide constate par
           Nicolas (30/09, rangee 2 direction droite, meme constat desktop).
           Repos = derniere carte visible (x=-maxShift), glisse vers 0
           (revele le debut de la piste) : symetrique de 'left'. */
        var x = s.direction === 'right' ? (shift - s.maxShift) : -shift;
        s.track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
      });
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    }

    measure();
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { measure(); update(); });
    /* measure()/update() tournent des DOMContentLoaded, avant que les images
       AU-DESSUS de la section (hero, autres sections) aient fini de charger.
       Si elles poussent la mise en page après coup, la position mesurée de
       la section (getBoundingClientRect) est fausse dès le départ — la
       rangée peut apparaître déjà décalée à son maximum au chargement, sans
       scroll (signalé par Nicolas le 29/09, mobile). 'load' attend TOUTES
       les ressources et recalcule sur la mise en page finale. */
    if (document.readyState === 'complete') {
      measure();
      update();
    } else {
      window.addEventListener('load', function () { measure(); update(); });
    }
  }

  function boot() {
    document.querySelectorAll('[data-el-spw]').forEach(initSpw);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) return;
    var root = event.target.querySelector('[data-el-spw]');
    if (root) initSpw(root);
  });
})();
/* resync-nudge 2026-09-29T3 */

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["eloence-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // -------- "See more" expand/collapse on clamped quotes --------
  function wireExpand(root) {
    (root || document).querySelectorAll('[data-el-testi-card]').forEach(function (card) {
      var quote = card.querySelector('[data-el-testi-quote]');
      var expand = card.querySelector('[data-el-testi-expand]');
      if (!quote || !expand) return;
      // Show expand button only if the quote actually overflows its clamp.
      function check() {
        // When expanded, treat as needed so user can collapse back.
        if (quote.classList.contains('is-expanded')) return;
        var overflows = quote.scrollHeight - quote.clientHeight > 1;
        expand.hidden = !overflows;
      }
      // Initial check after fonts/layout settle.
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(check);
      }
      window.requestAnimationFrame(check);
      window.addEventListener('resize', check);
      expand.addEventListener('click', function () {
        var now = quote.classList.toggle('is-expanded');
        expand.textContent = now
          ? (expand.dataset.labelLess || 'Voir moins')
          : (expand.dataset.labelMore || 'Voir plus');
      });
    });
  }
  wireExpand(document);

  // -------- Slider (arrows + dots + autoplay + loop) --------
  document.querySelectorAll('[data-el-testi-slides]').forEach(function (slides) {
    var track = slides.querySelector('.el-testimonials__track');
    if (!track) return;
    var prev = slides.querySelector('.el-testimonials__slide-prev');
    var next = slides.querySelector('.el-testimonials__slide-next');
    var dotsWrap = slides.querySelector('.el-testimonials__slide-dots');
    var slideEls = Array.prototype.slice.call(slides.querySelectorAll('.el-testimonials__slide'));
    var autoplay = slides.dataset.autoplay === 'true';
    var interval = parseInt(slides.dataset.interval || '6000', 10);
    var loop = slides.dataset.loop === 'true';

    var dots = slideEls.map(function (_, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'el-testimonials__slide-dot';
      d.setAttribute('aria-label', 'Aller à la diapo ' + (i + 1));
      d.addEventListener('click', function () { goToSlide(i); restartTimer(); });
      if (dotsWrap) dotsWrap.appendChild(d);
      return d;
    });

    // Find the slide whose left edge is closest to the track's left edge.
    // CAVEAT: this works because every slide is offset uniformly (track padding
    // + gap is constant per slide). If anyone introduces asymmetric padding or
    // a wider first-child margin, this will pick the wrong index. Keep slide
    // offsets uniform.
    function currentIndex() {
      if (slideEls.length === 0) return 0;
      var trackLeft = track.getBoundingClientRect().left;
      var best = 0, bestDist = Infinity;
      slideEls.forEach(function (s, i) {
        var d = Math.abs(s.getBoundingClientRect().left - trackLeft);
        if (d < bestDist) { bestDist = d; best = i; }
      });
      return best;
    }

    function goToSlide(i) {
      var max = slideEls.length;
      if (max === 0) return;
      if (i < 0) i = loop ? max - 1 : 0;
      if (i >= max) i = loop ? 0 : max - 1;
      var target = slideEls[i];
      if (!target) return;
      // Scroll the TRACK horizontally — never call target.scrollIntoView, which
      // also scrolls the page vertically when the testimonials section isn't
      // fully in view (the bug a user hit on iPhone after v1.0.5: autoplay
      // looping back to slide 1 yanked the page upward to the testimonials
      // section). track.scrollTo only moves the horizontal scroll inside the
      // track — never touches window scroll.
      var targetLeft = target.offsetLeft - track.offsetLeft;
      if (typeof track.scrollTo === 'function') {
        track.scrollTo({ left: targetLeft, behavior: reduced ? 'auto' : 'smooth' });
      } else {
        track.scrollLeft = targetLeft;
      }
    }

    function update() {
      var idx = currentIndex();
      dots.forEach(function (d, i) {
        var active = i === idx;
        d.classList.toggle('is-active', active);
        if (active) d.setAttribute('aria-current', 'true');
        else d.removeAttribute('aria-current');
      });
    }

    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    if (prev) prev.addEventListener('click', function () { goToSlide(currentIndex() - 1); restartTimer(); });
    if (next) next.addEventListener('click', function () { goToSlide(currentIndex() + 1); restartTimer(); });
    update();

    // -------- Autoplay --------
    // Pauses on hover / focus, resumes on leave / blur, resets on manual nav.
    var timer = null;
    function startTimer() {
      if (!autoplay || reduced || slideEls.length < 2) return;
      stopTimer();
      timer = setInterval(function () { goToSlide(currentIndex() + 1); }, interval);
    }
    function stopTimer() {
      if (timer) { clearInterval(timer); timer = null; }
    }
    function restartTimer() { stopTimer(); startTimer(); }
    slides.addEventListener('mouseenter', stopTimer);
    slides.addEventListener('mouseleave', startTimer);
    slides.addEventListener('focusin', stopTimer);
    slides.addEventListener('focusout', startTimer);
    startTimer();

    /* Editeur de theme : selectionner un avis dans la barre laterale amene sa
       slide dans l'apercu. Sans ca, l'editeur ne fait rien bouger : il pilote
       par selection de bloc, pas par clic.

       Branche ici et non via window.Eloence.onBlockSelect : goToSlide,
       slideEls et slides n'existent que dans cette closure, que le helper ne
       transmettrait pas. L'appartenance est filtree par slides.contains(card).

       L'autoplay est coupe pendant la selection, sinon la slide qu'on vient de
       choisir defilerait sous les yeux de l'editeur. Il repart a la
       deselection. En mode grille, [data-el-testi-slides] n'existe pas : cette
       closure ne s'execute pas et le hook n'est jamais pose. */
    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener('shopify:block:select', function (e) {
        if (!e.target || !e.target.closest) return;
        var card = e.target.closest('[data-el-testi-card]');
        if (!card || !slides.contains(card)) return;
        var i = slideEls.indexOf(card);
        if (i < 0) return;
        stopTimer();
        goToSlide(i);
      });
      document.addEventListener('shopify:block:deselect', function (e) {
        if (!e.target || !e.target.closest) return;
        var card = e.target.closest('[data-el-testi-card]');
        if (card && slides.contains(card)) startTimer();
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
